export enum ELayoutRemessaBoletos {
  Cnab240 = 1,
  Cnab400 = 2,
}
